// src/pages/HistorialEconomico.jsx
import React, { useEffect, useState } from 'react';
import { useParams, useHistory } from 'react-router-dom';
import axios from 'axios';
import Breadcrumb from '../components/Breadcrumb';
import '../styles/HistorialEconomico.css';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Select from 'react-select';
import ModalConfirmacion from "../components/ModalConfirmacion";

export default function HistorialEconomico() {
  const [resultados, setResultados] = useState([]);
  const { expediente } = useParams();
  const history = useHistory();
  const [actuaciones, setActuaciones] = useState([]);
  const [loading, setLoading] = useState(true);
  const [seleccionados, setSeleccionados] = useState([]);
  const [tratamientosDisponibles, setTratamientosDisponibles] = useState([]);
  const [paciente, setPaciente] = useState(null);
  const [descuento, setDescuento] = useState(0);
  const [descuentoEditado, setDescuentoEditado] = useState(false);
  const [modalEconomico, setModalEconomico] = useState(false);
  
  const calcularTotalFila = (act) => {
    if (!act.pagado) return 0;
    const cantidad = Number(act.cantidad || 1);
    const importe = Number(act.importe || 0);
    const descuento = Number(act.descuento || 0);
    const pendiente = Number(act.pendiente_pago || 0);

    let bruto = cantidad * importe;
    let neto = Math.max(bruto - descuento, 0);

    return Math.max(neto - pendiente, 0);
  };

  const guardarDescuentos = async () => {
    try {
      const payload = actuaciones
        .filter(a => seleccionados.includes(a.id))
        .map(a => ({
          id: a.id,
          descuento: a.descuento || 0
        }));

      await axios.put("/api/actuaciones/descuento", payload, {
        headers: { Authorization: `Bearer ${localStorage.getItem("token")}` }
      });

      toast.success("Descuentos guardados");
      setSeleccionados([]);
    } catch {
      toast.error("Error al guardar descuentos");
    }
  };

  const actualizarCampo = (id, campo, valor) => {
    setActuaciones(prev =>
      prev.map(act => {
        if (act.id !== id) return act;

        const max = Number(act.cantidad || 1) * Number(act.importe || 0);
        const limpio = Math.max(0, Math.min(Number(valor), max));

        return { ...act, [campo]: limpio };
      })
    );
  };

  const totalGlobal = actuaciones.reduce((acc, act) => {
    const totalFila = calcularTotalFila(act);
    return acc + (totalFila ?? 0);
  }, 0);

  const imprimirHistorialEconomico = async () => {
    const res = await axios.post(
      `/api/historial/economico/imprimir/${expediente}`,
      {},
      {
        responseType: "blob",
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`
        }
      }
    );

    const blob = new Blob([res.data], { type: "application/pdf" });
    window.open(URL.createObjectURL(blob), "_blank");
  };

  useEffect(() => {
    async function fetchPaciente() {
      try {
        const { data } = await axios.get(`/api/pacientes/${expediente}`, {
          headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
        });
        setPaciente(data);
      } catch (err) {
        console.error("Error al cargar paciente:", err);
      }
    }

    fetchPaciente();
  }, [expediente]);

  useEffect(() => {
    async function fetchHistorial() {
      try {
        const { data } = await axios.get(
          `/api/actuaciones/paciente/${expediente}`,
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem('token')}`
            }
          }
        );
        setResultados(data);
        setActuaciones(data);
      } catch (err) {
        console.error('Error al cargar historial', err.response || err);
      } finally {
        setLoading(false);
      }
    }

    fetchHistorial();
  }, [expediente]);


  useEffect(() => {
  async function fetchTratamientos() {
    try {
      const { data } = await axios.get('/api/tratamientos', {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`
        }
      });
      const opciones = data.map(t => ({
        value: t.nTratamiento,
        label: t.denominacion
      }));
      setTratamientosDisponibles(opciones);
    } catch (err) {
      console.error('Error al cargar tratamientos', err.response || err);
    }
  }

    fetchTratamientos();
  }, []);

  if (loading) return <p>Cargando historial económico...</p>;
  return (
    <>
      <ToastContainer />
      <div className="historial-economico-page">
      <Breadcrumb />
        <h2>
          Historial económico de{" "}
          {paciente
            ? [paciente.nombre, paciente.primer_apellido, paciente.segundo_apellido]
                .filter(Boolean)        
                .join(" ")
            : expediente}
        </h2>
        <table className="historial-table">
            <thead>
              <tr>
                <th></th>
                <th>ID</th>
                <th>Día</th>
                <th>Tratamiento</th>
                <th>Pieza</th>
                <th>Realizado</th>
                <th>Pagado</th>
                <th>Facturado</th>
                <th>Importe</th>
                <th>Pendiente</th>
                <th>Descuento</th>
                <th>Total</th>
              </tr>
            </thead>
            <tbody>
              {actuaciones.map(act => {
                return (
                  <tr key={act.id}>
                    <td>
                      <input
                        type="checkbox"
                        checked={seleccionados.includes(act.id)}
                        onChange={() =>
                          setSeleccionados(prev =>
                            prev.includes(act.id)
                              ? prev.filter(id => id !== act.id)
                              : [...prev, act.id]
                          )
                        }
                      />
                    </td>
                    <td>{act.id}</td>
                    <td>{act.dia}</td>
                    <td>{tratamientosDisponibles.find(t => t.value === act.tratamiento)?.label || act.tratamiento}</td>
                    <td>{act.n_pieza}</td>
                    <td>
                      <span className={act.realizado ? 'color-si' : 'color-no'}>
                          {act.realizado ? 'Sí' : 'No'}
                      </span>
                    </td>
                    <td>
                      <span className={act.pagado ? 'color-si' : 'color-no'}>
                          {act.pagado ? 'Sí' : 'No'}
                      </span>
                    </td>
                    <td>
                      <span className={act.n_factura ? 'color-si' : 'color-no'}>
                        {act.n_factura ? 'Sí' : 'No'}
                      </span>
                    </td>
                    <td>{act.importe}</td>
                    <td>{act.pendiente_pago} </td>  
                    <td>
                      {seleccionados.includes(act.id) ? (
                        <input
                          type="number"
                          step="0.01"
                          className="input-descuento"
                          value={act.descuento || ""}
                          onChange={e =>
                            actualizarCampo(act.id, "descuento", e.target.value)
                          }
                        />
                        ) : (
                        `${Number(act.descuento || 0).toFixed(2)} €`
                      )}
                    </td>
                    <td>
                      {calcularTotalFila(act) !== null
                        ? `${calcularTotalFila(act).toFixed(2)} €`
                        : ""}
                    </td>            
                  </tr>
                );
              })}
            </tbody>
            <tfoot>
                <tr>
                    <td colSpan={11} style={{ textAlign: "right", fontWeight: "bold" }}>Total:</td>
                     <td style={{ fontWeight: "bold" }}>{totalGlobal.toFixed(2)} €</td>

                </tr>
            </tfoot>
        </table>
        <div className="acciones-inferiores">
          <button
            className="accion-btn"
            onClick={() => setModalEconomico(true)}
          >
            Imprimir historial económico
          </button>      
          <button
            className="volver-btn"
            onClick={() => history.push(`/pacientes/${expediente}`)}
          >
            Volver al paciente
          </button>

          <button
            className="accion-btn guardar"
            disabled={seleccionados.length === 0}
            onClick={guardarDescuentos}
          >
            Guardar
          </button>
        </div>
      </div>
      <ModalConfirmacion
        abierto={modalEconomico}
        mensaje="¿Deseas imprimir el historial económico?"
        textoConfirmar="Imprimir"
        onConfirmar={() => {
          setModalEconomico(false);
          imprimirHistorialEconomico();
        }}
        onCancelar={() => setModalEconomico(false)}
      />
    </>
  );
}
